import { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { Container } from '@material-ui/core';
import { AdminForm } from 'components/Forms';
import { useStyles } from './styles';

const Admin: FC<any> = observer(({ type }) => {
  const classes = useStyles();
  return (
    <Container maxWidth='xl' className={classes.container}>
      <AdminForm type={type} />
    </Container>
  );
});

export default Admin;
